import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Table from 'src/components/UI/CustomUI/organisms/Table'
import { historyActions } from 'src/ducks/actions'
import { getOrderHistoryByJob } from 'src/ducks/history/selectors'
import { getEstimate } from 'src/ducks/selectors'
import headers from './headers'

const Dispatch = ({ id }: { id?: string }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const orderHistory = useSelector(getOrderHistoryByJob)
  const estimate = useSelector(getEstimate())

  const fetchOrderHistory = useCallback(() => {
    if (id) {
      dispatch(
        historyActions.fetchOrderHistoryByJob(id, (_succ: boolean) => {
          setLoading(false)
        })
      )
    }
  }, [dispatch, id])

  useEffect(() => {
    fetchOrderHistory()
  }, [fetchOrderHistory, estimate])

  return (
    <Table
      headers={headers}
      title='DISPATCH HISTORY'
      loading={loading}
      small
    >
      {orderHistory}
    </Table>
  )
}

export default Dispatch
